import styled from 'styled-components';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 15%;
  &.left-padding {
    margin-left: 20px;
  }
`;

export { ButtonContainer };
